module.exports = __webpack_public_path__ + "img/icon3@2x.bf965ea4.png";